import { Inject, Injectable, Optional } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { CmsModule } from '../../cms-generator/entity/cms-module';
import { CmsService } from '../../cms-generator/service/cms.service';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { navigateCrossPlatform } from 'src/app/util';
import { LoggerService } from 'src/app/share/service/logger.service';

@Injectable({
  providedIn: 'root',
})
export class CmsModuleResolverService implements Resolve<CmsModule> {
  /** 到首頁的路徑 */
  toHomePath: string;

  constructor(
    private templateService: TemplateService,
    private cmsService: CmsService,
    private router: Router,
    private serverConfigService: ServerConfigService,
    @Optional() @Inject(RESPONSE) private response: Response,
  ) {
    this.toHomePath = `/${serverConfigService.config.lang}`;
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CmsModule> {
    const cmsType = route.params['cmsType'];

    return this.cmsService.resolveCmsType(this.templateService.lang ,cmsType).pipe(
      catchError(error => {
        if (this.serverConfigService.isBrowser) {
          navigateCrossPlatform(this.serverConfigService.isBrowser, this.router, this.response, [`${this.toHomePath}/404`]);
          return throwError(error);
        } else {
          this.response.status(500);
          return of(undefined);
        }
      }));
  }
}
